import { render } from "./key-tips.vue?vue&type=template&id=3e338454&scoped=true&ts=true"
import script from "./key-tips.vue?vue&type=script&lang=ts"
export * from "./key-tips.vue?vue&type=script&lang=ts"

import "./key-tips.vue?vue&type=style&index=0&id=3e338454&lang=scss&scoped=true"

import exportComponent from "/workspace/ops/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.2.47_vue@3.2.47_webpack@4.46.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e338454"]])

export default __exports__